// Typelizer digest 16b2141727150aceaf5f9206132ec2e4
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /educators/team_applications */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/team_applications', {}, options),
    method: 'post',
  }),

  /** GET /educators/team_applications/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/team_applications/new', {}, options),
    method: 'get',
  }),

  /** GET /educators/team_applications/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/team_applications/:id', params, options),
    method: 'get',
  }),
}
